import { ApplicationType } from "../../../api/axcloud";
import { SelectorOptionType } from "../../../components/ViewOnlySelector";

export const useAppTypeOption = () => {
  const appTypeOptions: SelectorOptionType[] = [
    {
      value: ApplicationType.Native,
      label: ApplicationType.Native,
    },
    {
      value: ApplicationType.Web,
      label: ApplicationType.Web,
    },
  ];

  return { appTypeOptions };
};
